import React from "react";

export default function Menu() {
  const headers = [
    { label: "Symbol Name", width: "w-1/4" },
    { label: "Min Qty", width: "w-1/6" },
    { label: "Order Qty", width: "w-1/6" },
    { label: "Total Qty", width: "w-1/6" },
    { label: "Lot-Size", width: "w-1/6" },
  ];

  return (
    <div className="flex flex-wrap md:flex-nowrap items-center justify-between bg-[var(--background)] rounded-xl shadow-sm border-2 border-[var(--hover)] p-3">
      {headers.map((item, i) => (
        <div
          key={i}
          className={`${item.width} text-center font-semibold text-[10px] text-[var(--text)] uppercase tracking-wide`}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
}
